<template>
	<div class="m-portlet">
	    <div class="m-portlet__head">
			<div class="m-portlet__head-caption">

			</div>
			<div class="m-portlet__head-tools">
				<a @click="this.modalCreateSub" class="btn btn-primary pull-right">
					Tạo tài khoản phụ
				</a>
			</div>
	    </div>
	    <div class="m-portlet__body">
			<data-table 
				tableId="sub_acc_list"
				:header="this.tableHeader"
				:columns="this.tableColumns"
				:columnDefs="this.columnDefs"
				:columnSearch="this.columnSearch"
				:data="this.users"
				:onEditRow="this.openEditAccount"
			/>
	    </div>
		<div class="modal fade show" id="sub_account_modal" tabindex="-1" role="dialog" aria-labelledby="modalTitle">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-group m-form__group row">
							<label for="sub_username" class="col-3 col-form-label">Tên đăng nhập</label>
							<div class="col-9">
								<input disabled class="form-control m-input" type="text" v-model="subUsername">
							</div>
						</div>
						<div class="form-group m-form__group row">
							<label for="sub_username" class="col-3 col-form-label">Tên</label>
							<div class="col-9">
								<input class="form-control m-input" type="text" v-model="subFullname">
							</div>
						</div>
						<div class="form-group m-form__group row">
							<label for="sub_password" class="col-3 col-form-label">Mật khẩu</label>
							<div class="col-9">
								<input class="form-control m-input" type="password" v-model="subPassword">
							</div>
						</div>
						<div class="form-group m-form__group row">
							<label for="sub_password" class="col-3 col-form-label">Quyền</label>
							<div class="col-9">
								<div><input type="checkbox" val="" id="sub_report_permission">Xem báo cáo</div>
								<div><input type="checkbox" id="sub_acc_permission">Qlý tài khoản, tăng cò, khóa số</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
	                    <button type="button" class="btn btn-secondary" data-dismiss="modal">
	                        Hủy bỏ
	                    </button>
	                    <button type="button" class="btn btn-primary" @click="this.create">
	                        {{this.mode == "create" ? "Tạo" : "Cập nhật"}}
	                    </button>
	                </div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import DataTable from "../DataTable";

	export default {
		props: ["breadcrumb"],

		data(){
			let vm = this;

	        return {
	        	"tableHeader": ["Tài khoản","Tên","Quyền","Trạng thái","Last login"],
	        	"tableColumns": [{data: 'code'},{data: 'fullname'},{data: 'permission'},{data: 'status'},{data: 'last_login'}],
	        	"columnSearch": [{pos:0}, {pos:4,type:"date"}],
	        	"columnDefs": [
	        		{
						targets: 0,//code
						render: function(data, type, full, meta) {
							let uname = data.toUpperCase();
                            
                            return "<span class='code' style='float: left;'>"+uname+"</span>";
						}
					},
					{
						targets: 2,
						render: function(data, type, full, meta) {
							let per = data.split(",").map((e)=>{ return vm.quyen[e]; });
							return per.join(", ");
						}
					},
					{
						targets: 3,
						render: function(data, type, full, meta) {
							let dis = vm.user.status != 1 ? "disabled" : "";
							return  '<select '+dis+' class="form-control user_status" origin="'+data+'" code="'+full.code+'">' +
										'<option '+(data == 1 ? 'selected' : '')+' value="1">Mở</option>' +
	                                    '<option '+(data == -1 ? 'selected' : '')+' value="-1">Khóa</option>' +
									'</select>';
						}
					},
					{
						targets: 4,
						render: function(data, type, full, meta) {
							let d = moment(data, "YYYY/MM/DD HH:mm:ss").format('DD/MM/YYYY HH:mm:ss');
							return d == "Invalid date" ? "" : d;
						}
					}
	        	],

	        	"users": [],
	        	"mode": "create",
	        	"subUsername": "",
	        	"subPassword": "",
	        	"subFullname": "",
	        	"subCode": "",
	        	"quyen": {
	        		"report_sub": "Xem báo cáo",
	        		"create_sub": "QL Tài khoản",
	        		"commission": "tăng cò",
	        		"lock_number": "khóa số"
	        	}
	        }
	    },

	    created() {
	    	this.updateUsername();
	    	this.fetchSubAccountList(this.user.code);
	    },

	    mounted(){
	    	let vm = this;

	    	vm.initTable();
	    	$("#sub_account_modal").on("hide.bs.modal", (e) => {
	    		vm.clearModal();
	    	});
	    	$("#sub_account_modal").on("show.bs.modal", (e) => {
	    		vm.updateUsername();
	    	});
	    },

	    watch: {
	    	users: function(u){
	    		this.updateUsername();
	    	}
	    },

	    components: {
			'data-table': DataTable
		},

	    computed: {
			...mapGetters({
		  		user: 'user'
			}),
		},

		methods:{
			initTable: function(){
				var vm = this;
				let params = this.$route.params;
				
				$(document).off("change", ".user_status");
                $(document).on("change", ".user_status", function(){
                	var current = $(this);
                    let ucode = current.attr("code");
                    let stt = current.val();
                    let origin = current.attr("origin");
                    let text = stt == -1 ? "khóa" : "mở";

                    let swalOpt = {
                        title: "Bạn chắc chắn muốn " + text + " tài khoản &nbsp;<span style='color: red'>"+ ucode +"</span>?",
                        showCancelButton: true,
                        confirmButtonText: text,
                        cancelButtonText: "Hủy bỏ",
                        confirmButtonColor: "#cb5a5e",
                        allowOutsideClick: false
                    };
             
                    swal(swalOpt).then(res => {
                    	if(res.dismiss){
                    		current.find("option").removeAttr("selected");
                        	current.find("option[value="+origin+"]").prop("selected", true);
                    	}else{
	                        vm.banUser(stt, ucode);
                    	}
                    });
                });
			},

			clearModal: function(){
				this.subUsername = "";
               	this.subFullname = "";
               	this.subPassword = "";
               	$("#sub_report_permission").prop('checked', false);
               	$("#sub_acc_permission").prop('checked', false);
			},

			updateUsername: function(){
				if(this.mode != "edit"){
					let count = this.users ? this.users.length: 0;
					this.subCode = count > 9 ? count : "0" + count
	    			this.subUsername = this.user.username + "sub" + this.subCode;
				}
			},

			modalCreateSub: function(){
				this.mode = "create";
				$("#sub_account_modal").modal();
			},

			banUser: function(stt, ucode){
				let vm = this;
				axios.put("/admin-panel/user/ban/"+ucode, { status: stt })
					.then(res => {
						vm.fetchSubAccountList(vm.user.code);
					});
			},

			create: async function(){
				let rpPermission = $("#sub_report_permission").is(':checked');
				let accPermission = $("#sub_acc_permission").is(':checked');
				
				let data = {
					usercode: this.subCode,
					password: this.subPassword,
					fullname: this.subFullname
				};

				data.permission = rpPermission && accPermission ? 10 : (rpPermission ? 8 : (accPermission?9:7));

				if(this.mode == "create"){
					let url = 'admin-panel/user/sub/create';
					let res = await axios.post(url, data);
				}else{
					let url = 'admin-panel/user/sub/update/'+ this.subCode;
					let res = await axios.put(url, data);
				}

				$("#sub_account_modal").modal('hide');
            	this.fetchSubAccountList(this.user.code);
			},

			fetchSubAccountList: async function(code, callback = null){
				code = code ? code : "";

				let url = 'admin-panel/user/sub_childs';
				let res = await axios.get(url);
				res = res.data;

				this.users = res.data;

				if(callback) callback();
			},

			openEditAccount: function(ucode){
				let vm = this;

               	let u = vm.users.filter((e) => {return e.code == ucode});
               	if(u.length == 0) return;
               	u = u[0];
               	
               	if(u.permission.indexOf("report_sub") >= 0){
               		$("#sub_report_permission").prop('checked', true);
               	}

               	if(u.permission.indexOf("create_sub") >= 0){
               		$("#sub_acc_permission").prop('checked', true);
               	}

               	vm.subUsername = u.username;
               	vm.subFullname = u.fullname;
               	vm.subCode = u.code;
               	vm.mode = "edit";

               	$("#sub_account_modal").modal();
			}
		}
	}
</script>